<script>
/**
 * Page footer. Shows jurisdiction, footer text, and the "Computer Generated"
 * line. Browsers don't reliably honour `position: running()` for repeating
 * headers/footers across pages, so we render this *inside the last `.print-page`*
 * and accept that on multi-page invoices the footer only appears at the bottom
 * of the last page. Static reports rarely paginate; vouchers usually fit one
 * page anyway.
 */
export default {
  name: "PrintFooter",
  inject: { printProfile: { default: () => () => null } },
  props: {
    showComputerGenerated: { type: Boolean, default: true },
  },
  computed: {
    profile() { return this.printProfile(); },
    footerText() { return this.profile?.footerText || ""; },
    jurisdictionText() { return this.profile?.jurisdictionText || ""; },
  },
};
</script>

<template>
  <footer class="print-footer">
    <div v-if="footerText" class="print-footer-text">{{ footerText }}</div>
    <div v-if="jurisdictionText" class="print-footer-jurisdiction">
      <strong>Jurisdiction:</strong> {{ jurisdictionText }}
    </div>
    <div v-if="showComputerGenerated" class="print-footer-cg">
      This is a computer-generated document. No signature required.
    </div>
  </footer>
</template>

<style scoped>
.print-footer {
  margin-top: 4mm;
  padding-top: 1.5mm;
  border-top: 0.25pt solid var(--print-border);
  text-align: center;
  font-size: var(--print-fs-xs);
  color: var(--print-muted);
  line-height: 1.4;
}

.print-footer-text {
  margin-bottom: 0.5mm;
}

.print-footer-jurisdiction {
  margin-bottom: 0.5mm;
}

.print-footer-cg {
  font-style: italic;
  letter-spacing: 0.02em;
}
</style>
